module.exports = __webpack_public_path__ + "static/img/zd.21c789e7.png";